export const passosTutorialReembolso = {
  1: [
    {
      chave: 'etapa-beneficiario',
      titulo: '1. Identificação',
      descricao: 'Selecione qual beneficiário foi atendido. Você poderá solicitar reembolso em seu nome ou de um de seus dependentes. ',
      posicao: 'bottom',
    },
  ],
  2: [
    {
      chave: 'etapa-despesas',
      titulo: '2. Despesas',
      descricao: 'Informe os dados do atendimento. Ao digitar o CPF ou CNPJ informe o nome do prestador, caso o mesmo não apareça automaticamente.',
      posicao: 'bottom',
    }
  ],
  3: [
    {
      chave: 'etapa-documentos',
      titulo: '3. Documentos',
      descricao: 'Anexe fotos ou PDFs dos seus comprovantes. Use o campo "Justificativa" para explicar os motivos da solicitação.',
      posicao: 'bottom',
    }
  ],
  4: [
    {
      chave: 'etapa-bancarios',
      titulo: '4. Dados Bancários',
      descricao: 'Escolha o banco e agência para receber o reembolso. O sistema validará os dados antes de você avançar.',
      posicao: 'bottom',
    }
  ],
  5: [
    {
      chave: 'etapa-protocolo',
      titulo: '5. Protocolo',
      descricao: 'Pronto! Ao enviar, será gerado o número de protocolo. Guarde-o para acompanhar sua solicitação.',
      posicao: 'bottom',
    }
  ],
};
